// src/pages/Coaching.jsx
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Form1 from "../components/Form1";
import "../css/coaching.css";
import CoachingExtras from "../components/CoachingExtras";
import Banner from "../components/Banner";

export default function Coaching() {
  // Scroll morbido al form e focus sul select "package"
  const goToFormAndFocusPackage = () => {
    const formWrap = document.getElementById("consultation-form");
    if (formWrap) {
      formWrap.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    // diamo un attimo al browser per scrollare prima di focussare
    window.setTimeout(() => {
      const pkg = document.querySelector("#consultation-form select#package");
      if (pkg) pkg.focus({ preventScroll: true });
    }, 400);
  };

  // Accessibilità: consente "Enter/Space" sulla card
  const cardKeyHandler = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      goToFormAndFocusPackage();
    }
  };

  return (
    <main className="coaching-page">
      {/* Hero Preface */}
      <section className="coaching-hero py-5">
        <Container>
          <Row className="justify-content-center text-center">
            <Col lg={10} xl={8}>
              <h1 className="coaching-title">UNLOCK YOUR PERFORMANCE</h1>
              <p className="coaching-lead">
                Coaching is more than just sets and reps. It’s about building a
                resilient mindset, mastering movement quality, and developing
                sustainable habits that last a lifetime. Whether your goal is
                fat loss, muscle growth, or pure strength, I’ll guide you step
                by step with a program that adapts to your lifestyle and keeps
                you motivated.
              </p>
              <p className="coaching-lead mt-2">
                We’ll connect via <strong>WhatsApp</strong> for coaching calls,
                check-ins, and quick follow-ups.
              </p>
              <p className="coaching-lead">
                Take the first step today—fill out the form below and let’s
                start shaping your transformation together.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Coaching Packages */}
      <section className="packages py-5">
        <Container>
          <Row className="justify-content-center text-center">
            <Col lg={10}>
              <h2 className="packages-title">Online Coaching Packages</h2>
              <p className="packages-subtitle text-black">
                Explore the options, then{" "}
                <strong>select your package below</strong> in the form.
              </p>
            </Col>
          </Row>

          <Row className="g-4 align-items-stretch mt-1">
            {/* Weekly */}
            <Col md={6} lg={3}>
              <article
                className="package-card h-100 package-card--clickable"
                role="button"
                tabIndex={0}
                onClick={goToFormAndFocusPackage}
                onKeyDown={cardKeyHandler}
                aria-label="Go to form to select the Weekly package"
              >
                <header className="package-header">
                  <h3 className="package-name">Weekly</h3>
                  <div className="package-price">
                    <span className="price-main">€39,99 EUR</span>
                    <span className="price-period text-dark">/week</span>
                  </div>
                </header>

                <ul className="package-features">
                  <li>
                    Exercise programming based on individual objectives &
                    activity level (Beginner / Intermediate / Advanced)
                  </li>
                  <li>24-hour support</li>
                  <li>Technique guidance + exercise corrections via video</li>
                  <li>Scheduled video call consultation on progress</li>
                </ul>
              </article>
            </Col>

            {/* Monthly */}
            <Col md={6} lg={3}>
              <article
                className="package-card package-card--highlight h-100 package-card--clickable"
                role="button"
                tabIndex={0}
                onClick={goToFormAndFocusPackage}
                onKeyDown={cardKeyHandler}
                aria-label="Go to form to select the Monthly package"
              >
                <div className="package-badge">
                  <span className="save">Save €50/mo</span>
                  <span className="strike text-dark">instead €200/m</span>
                </div>

                <header className="package-header">
                  <h3 className="package-name">Monthly</h3>
                  <div className="package-price">
                    <span className="price-main">€139,99 EUR</span>
                    <span className="price-period text-dark">/month</span>
                  </div>
                </header>

                <ul className="package-features">
                  <li>
                    Exercise programming based on individual objectives &
                    activity level (Beginner / Intermediate / Advanced)
                  </li>
                  <li>24-hour support</li>
                  <li>Technique guidance + exercise corrections via video</li>
                  <li>Scheduled video call consultation on progress</li>
                </ul>
              </article>
            </Col>

            {/* 3 months (NUOVO) */}
            <Col md={6} lg={3}>
              <article
                className="package-card h-100 package-card--clickable"
                role="button"
                tabIndex={0}
                onClick={goToFormAndFocusPackage}
                onKeyDown={cardKeyHandler}
                aria-label="Go to form to select the 3-Month package"
              >
                <div className="package-badge">
                  <span className="save">Save vs monthly</span>
                  <span className="strike text-dark">instead €419,97</span>
                </div>

                <header className="package-header">
                  <h3 className="package-name">3-Month Course</h3>
                  <div className="package-price">
                    <span className="price-main">€249,99 EUR</span>
                    <span className="price-period text-dark">/3 months</span>
                  </div>
                </header>

                <ul className="package-features">
                  <li>
                    Exercise programming based on individual objectives &
                    activity level (Beginner / Intermediate / Advanced)
                  </li>
                  <li>24-hour support</li>
                  <li>Technique guidance + exercise corrections via video</li>
                  <li>Scheduled video call consultation on progress</li>
                </ul>
              </article>
            </Col>

            {/* 6 months */}
            <Col md={6} lg={3}>
              <article
                className="package-card h-100 package-card--clickable"
                role="button"
                tabIndex={0}
                onClick={goToFormAndFocusPackage}
                onKeyDown={cardKeyHandler}
                aria-label="Go to form to select the 6-Month package"
              >
                <div className="package-badge">
                  <span className="save">Save €300</span>
                  <span className="strike text-dark">instead €900</span>
                </div>

                <header className="package-header">
                  <h3 className="package-name">6-Month Course</h3>
                  <div className="package-price">
                    <span className="price-main">€599,99 EUR</span>
                    <span className="price-period text-dark">/6 months</span>
                  </div>
                </header>

                <ul className="package-features">
                  <li>
                    Exercise programming based on individual objectives &
                    activity level (Beginner / Intermediate / Advanced) with
                    6-week updated and advanced training programs
                  </li>
                  <li>Motivation & technical support to be your best self</li>
                  <li>24-hour support</li>
                  <li>Technique guidance + exercise corrections via video</li>
                  <li>Scheduled video call consultation on progress</li>
                </ul>
              </article>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Intro vicina al form */}
      <div id="formcontainer">
        <section className="coaching-intro text-center py-4">
          <Container>
            <Row className="justify-content-center">
              <Col lg={8}></Col>
            </Row>
          </Container>
        </section>
      </div>

      {/* L'ID serve per l'ancora e per query/focus */}
      <div id="consultation-form">
        <Form1 showHero={false} leadSource="coaching" />
      </div>

      <CoachingExtras />
      <Banner />
    </main>
  );
}
